
export default function WhyItWorks() {
  return (
    <section className="py-20 bg-gradient-to-br from-white via-purple-50/30 to-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="bg-white rounded-3xl p-12 lg:p-16 shadow-2xl border border-gray-100">
          {/* Opening Statement */}
          <div className="text-center mb-12">
            <p className="text-2xl lg:text-3xl text-gray-800 leading-relaxed font-light mb-6 font-inter">
              Como <strong className="text-purple-600 font-bold">atleta e personal trainer</strong>, eu sei exatamente o que bloqueia a tua evolução — <span className="text-gray-900 font-semibold">técnica errada, treino mal estruturado, exercícios que não fazem sentido para o seu objetivo e falta de progressão</span>.
            </p>
            <p className="text-3xl lg:text-4xl text-purple-600 font-bold font-montserrat">
              E é isso que eu vim resolver.
            </p>
          </div>

          {/* Divider */}
          <div className="w-32 h-1 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full mx-auto my-12"></div>

          {/* Main Value Proposition */}
          <div className="mb-12">
            <p className="text-xl lg:text-2xl text-gray-800 leading-relaxed mb-6 text-center font-inter">
              Na minha consultoria, você recebe <strong className="text-purple-600">treinos profissionais</strong>, pensados para o seu nível, seu tempo, sua rotina e principalmente para o <strong className="text-purple-600">seu objetivo</strong>.
            </p>
            
            <div className="flex flex-wrap justify-center gap-6 mb-8">
              <div className="flex items-center bg-purple-50 rounded-full px-6 py-3">
                <i className="ri-close-circle-fill text-purple-600 mr-2 text-xl"></i>
                <span className="text-lg font-semibold text-gray-800 font-poppins">Sem achismos</span>
              </div>
              <div className="flex items-center bg-purple-50 rounded-full px-6 py-3">
                <i className="ri-close-circle-fill text-purple-600 mr-2 text-xl"></i>
                <span className="text-lg font-semibold text-gray-800 font-poppins">Sem copiar influenciadora</span>
              </div>
              <div className="flex items-center bg-purple-50 rounded-full px-6 py-3">
                <i className="ri-close-circle-fill text-purple-600 mr-2 text-xl"></i>
                <span className="text-lg font-semibold text-gray-800 font-poppins">Sem perder tempo</span>
              </div>
            </div>
          </div>

          {/* The Problem */}
          <div className="mb-12">
            <div className="flex items-start justify-center mb-8">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                <i className="ri-lightbulb-fill text-purple-600 text-2xl"></i>
              </div>
              <div className="flex-1">
                <p className="text-xl lg:text-2xl text-gray-800 leading-relaxed font-inter">
                  Com o tempo, percebi que a maioria das mulheres não deixa de evoluir por <strong>falta de esforço</strong>… mas por <strong className="text-purple-600">falta de direção</strong>.
                </p>
              </div>
            </div>
            
            <p className="text-lg lg:text-xl text-gray-700 leading-relaxed mb-4 text-center font-inter">
              É difícil mesmo saber se está fazendo certo, se está treinando o que precisa ou se está apenas repetindo movimentos.
            </p>
            
            <p className="text-xl lg:text-2xl text-gray-800 font-semibold text-center font-poppins">
              E ninguém merece se dedicar tanto para ver tão pouco resultado.
            </p>
          </div>

          {/* Divider */}
          <div className="w-32 h-1 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full mx-auto my-12"></div>

          {/* Key Insight */}
          <div className="mb-12">
            <div className="text-center mb-8">
              <div className="inline-block bg-purple-100 rounded-full px-8 py-3">
                <p className="text-purple-600 font-bold text-xl font-poppins">O Segredo</p>
              </div>
            </div>
            
            <p className="text-xl lg:text-2xl text-gray-800 text-center leading-relaxed mb-6 font-inter">
              Não é sobre treinar mais ou extremamente pesado com volumes infinitos de séries e repetições.
            </p>
            
            <p className="text-2xl lg:text-3xl text-purple-600 font-bold text-center leading-relaxed font-montserrat">
              É sobre treinar melhor — com objetivo, com alguém que entende o que você sente e sabe para onde você pode ir.
            </p>
          </div>

          {/* Final Call */}
          <div className="text-center">
            <p className="text-2xl lg:text-3xl font-semibold leading-relaxed text-gray-800 mb-2 font-inter">
              Se você quiser dar esse próximo passo,
            </p>
            <p className="text-3xl lg:text-4xl font-bold text-purple-600 mb-8 font-montserrat">
              eu estou aqui para te guiar.
            </p>
            
            <div className="flex items-center justify-center space-x-4">
              <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center">
                <i className="ri-heart-fill text-purple-600 text-2xl"></i>
              </div>
              <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center">
                <i className="ri-star-fill text-purple-600 text-2xl"></i>
              </div>
              <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center">
                <i className="ri-trophy-fill text-purple-600 text-2xl"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
